/** The Spanish catalogue for being out of play — the wording only. Why each entry exists is argued in `en/sanction.ts`. */
export default {
  title_foul: 'SANCIÓN DISCIPLINARIA',
  title_hit: 'IMPACTO',
  title_fall: 'CAÍDA',

  foul_referee: 'Disparaste al árbitro.',
  foul_animal: 'Disparaste a un animal.',
  foul_min_range: 'Disparaste dentro de la distancia mínima.',
  foul_smoke_indoor: 'Lanzaste humo dentro de una estructura. El humo es solo para exteriores.',
  foul_smoke_direct: 'Lanzaste la granada directamente al cuerpo de un jugador.',
  foul_vehicle: 'Te atropelló un vehículo. En el camino, la prioridad no es tuya.',

  hit_by: 'Te dio de baja:',
  fell_from: 'Bajaste por una pendiente que no se puede caminar.',
  out_of_play: 'FUERA DE JUEGO',
  back_at_zero: 'Vuelves al juego cuando el conteo llegue a cero.',

  // ── the warning, which is not a sanction ──────────────────────────────────────────────────────────
  warning: 'APERCIBIMIENTO',
  warning_offence: 'Disparo dentro de la distancia mínima. El impacto no cuenta.',
  warning_line: '{d} m · tu mínima es {min} m',
  warning_count: '{n} de {of}',

  // ── the log line, which is what is left afterwards ────────────────────────────────────────────────
  log_self: 'SANCIÓN — le disparaste al árbitro · {s} s fuera',
  log_other: '#{id} sancionado — le disparó al árbitro · {s} s fuera',
};
